module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padre"
  }, [_vm._m(0), (_vm.closeComponentJefe) ? _c('div', {
    staticClass: "message-body"
  }, [_c('strong', [_vm._v("No tiene pendientes")])]) : _vm._e(), _c('div', {
    staticClass: "display-flex fdc"
  }, [_c('div', {
    staticClass: "jefe display-flex fdr space-evenly flex-wrap"
  }, [(_vm.showCantidadContratosPorVencerJefe) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('contratos-equipo')
      }
    }
  }, [_c('cantidad-contratos-por-vencer-jefe', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadContratosPorVencerJefe')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadSolicitudesVSinAprobarJefe) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('vacaciones-equipo')
      }
    }
  }, [_c('cantidad-solicitudes-v-sin-aprobar-jefe', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadSolicitudesVSinAprobarJefe')
      }
    }
  })], 1) : _vm._e(), (_vm.showCantidadPermisosSinAprobarJefe) ? _c('div', {
    staticClass: "card-component",
    on: {
      "click": function($event) {
        return _vm.redirigir('permisos-equipo')
      }
    }
  }, [_c('cantidad-permisos-sin-aprobar-jefe', {
    on: {
      "close": function($event) {
        return _vm.close('showCantidadPermisosSinAprobarJefe')
      }
    }
  })], 1) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Mis pendientes como jefe")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-435327a7","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Dashboard_KPI_jefe.vue
// module id = 801
// module chunks = 0